import type { PharosAuthState } from './pharos-auth-context';

/**
 * Fields common to every signed-out `PharosAuthState` transition — spread and override
 * `error`/`sessionEndedReason` at each call site. Kept in its own module (rather than declared
 * in `pharos-auth-context.tsx`) so `use-impersonation-session.ts` can import the value without
 * creating a runtime circular dependency between the two files (only the type is imported here).
 */
export const SIGNED_OUT_STATE: Pick<
  PharosAuthState,
  'isAuthenticated' | 'isImpersonating' | 'isLoading' | 'klareoToken' | 'user'
> = {
  isAuthenticated: false,
  isImpersonating: false,
  isLoading: false,
  klareoToken: null,
  user: null,
};
